import AdUnit from "./AdUnit";
import {
  ADSENSE_MULTIPLEX_HORIZONTAL_SLOT,
  ADSENSE_MULTIPLEX_VERTICAL_SLOT,
} from "../../config/adsense.js";

export default function MultiplexAd({ orientation = "horizontal", onSlotStateChange }) {
  const isVertical = orientation === "vertical";
  const slot = isVertical
    ? ADSENSE_MULTIPLEX_VERTICAL_SLOT
    : ADSENSE_MULTIPLEX_HORIZONTAL_SLOT;

  return (
    <AdUnit
      slot={slot}
      className="ad-slot--multiplex"
      format="autorelaxed"
      style={{ display: "block" }}
      fullWidthResponsive="true"
      collapseIfEmpty
      onSlotStateChange={onSlotStateChange}
    />
  );
}
